import type { TranslationCatalog } from '../../shared/i18n';

export const translations: TranslationCatalog = {
  "Aktiv / Passiv": {
    "tr": "Aktif / Pasif",
    "en": "Active / Inactive"
  },
  "Letzter Einkauf": {
    "tr": "Son alış",
    "en": "Last purchase"
  },
  "Artikelstamm": {
    "tr": "Ürün kartları",
    "en": "Products"
  },
  "Artikel": {
    "tr": "Ürün",
    "en": "Product"
  },
  "Artikel auswählen": {
    "tr": "Ürün seç",
    "en": "Select product"
  },
  "Artikelsuche": {
    "tr": "Ürün arama",
    "en": "Product search"
  },
  "Andern": {
    "tr": "Düzenle",
    "en": "Edit"
  },
  "Dupliziren": {
    "tr": "Çoğalt",
    "en": "Duplicate"
  },
  "Die Desktop-Schaltfläche hat keine Löschfunktion. Artikel auf Passiv setzen.": {
    "tr": "Masaüstündeki düğmenin silme işlevi yok. Ürünü pasif yapın.",
    "en": "The desktop button has no delete action. Set the product to inactive."
  },
  "Druck und Berichte werden in einer späteren Phase umgesetzt.": {
    "tr": "Yazdırma ve raporlar sonraki aşamada eklenecek.",
    "en": "Printing and reports will be added in a later phase."
  },
  "Drucken (später)": {
    "tr": "Yazdır (sonraki aşama)",
    "en": "Print (later)"
  },
  "Suche": {
    "tr": "Ara",
    "en": "Search"
  },
  "Art.Nr / Bezeichnung (* trennt Suchbegriffe)": {
    "tr": "Ürün no. / Açıklama (* arama sözcüklerini ayırır)",
    "en": "Product no. / Description (* separates search terms)"
  },
  "Status": {
    "tr": "Durum",
    "en": "Status"
  },
  "Alle": {
    "tr": "Tümü",
    "en": "All"
  },
  "<Alle>": {
    "tr": "<Tümü>",
    "en": "<All>"
  },
  "Aktiv": {
    "tr": "Aktif",
    "en": "Active"
  },
  "Passiv": {
    "tr": "Pasif",
    "en": "Inactive"
  },
  "Marka": {
    "tr": "Marka",
    "en": "Brand"
  },
  "Gruppe": {
    "tr": "Grup",
    "en": "Group"
  },
  "Lager": {
    "tr": "Depo",
    "en": "Warehouse"
  },
  "Alle gefilterten Artikel werden geladen …": {
    "tr": "Filtrelenen tüm ürünler yükleniyor …",
    "en": "Loading all filtered products …"
  },
  "Artikel werden geladen …": {
    "tr": "Ürünler yükleniyor …",
    "en": "Loading products …"
  },
  "Alle +1": {
    "tr": "Tümüne +1",
    "en": "All +1"
  },
  "Gruppe wechseln": {
    "tr": "Grubu değiştir",
    "en": "Change group"
  },
  "Gruppe wählen": {
    "tr": "Grup seç",
    "en": "Select group"
  },
  "Gruppe übernehmen …": {
    "tr": "Grubu uygula …",
    "en": "Apply group …"
  },
  "{count} Artikel": {
    "tr": "{count} ürün",
    "en": "{count} products"
  },
  " · Auswahl: {code}": {
    "tr": " · Seçim: {code}",
    "en": " · Selected: {code}"
  },
  "Art.Nr": {
    "tr": "Ürün no.",
    "en": "Product no."
  },
  "Artikel Nr.": {
    "tr": "Ürün no.",
    "en": "Product no."
  },
  "Bezeichnung": {
    "tr": "Açıklama",
    "en": "Description"
  },
  "Bezeichnung-2": {
    "tr": "Açıklama-2",
    "en": "Description-2"
  },
  "Bezeichnung-3": {
    "tr": "Açıklama-3",
    "en": "Description-3"
  },
  "Bezeichnung 2": {
    "tr": "Açıklama 2",
    "en": "Description 2"
  },
  "Verpackung": {
    "tr": "Ambalaj",
    "en": "Packaging"
  },
  "VPE": {
    "tr": "Koli içi",
    "en": "Pack size"
  },
  "VPE-Menge": {
    "tr": "Koli miktarı",
    "en": "Pack quantity"
  },
  "VPE Menge": {
    "tr": "Koli miktarı",
    "en": "Pack quantity"
  },
  "Vk1": {
    "tr": "Satış 1",
    "en": "Sale 1"
  },
  "Vk2": {
    "tr": "Satış 2",
    "en": "Sale 2"
  },
  "Vk3": {
    "tr": "Satış 3",
    "en": "Sale 3"
  },
  "Vk4": {
    "tr": "Satış 4",
    "en": "Sale 4"
  },
  "Akt Bestand": {
    "tr": "Mevcut stok",
    "en": "Current stock"
  },
  "Ust": {
    "tr": "KDV",
    "en": "VAT"
  },
  "Bruttogewicht (Kg)": {
    "tr": "Brüt ağırlık (Kg)",
    "en": "Gross weight (Kg)"
  },
  "EK": {
    "tr": "Alış fiyatı",
    "en": "Cost"
  },
  "EK %": {
    "tr": "Alış %",
    "en": "Cost %"
  },
  "Keine Artikel gefunden.": {
    "tr": "Ürün bulunamadı.",
    "en": "No products found."
  },
  "Änderungen verwerfen?": {
    "tr": "Değişikliklerden vazgeçilsin mi?",
    "en": "Discard changes?"
  },
  "Artikel gespeichert.": {
    "tr": "Ürün kaydedildi.",
    "en": "Product saved."
  },
  "Speicherergebnis unklar. „Erneut speichern“ wiederholt dieselbe Anfrage ohne doppelten Artikel.": {
    "tr": "Kaydetme sonucu belirsiz. “Yeniden kaydet” aynı isteği tekrarlayarak ürünün iki kez oluşmasını önler.",
    "en": "Save outcome is uncertain. “Save again” repeats the same request without creating a duplicate product."
  },
  "Wird beim Speichern vergeben": {
    "tr": "Kaydederken atanır",
    "en": "Assigned when saved"
  },
  "Steuer %": {
    "tr": "Vergi %",
    "en": "Tax %"
  },
  "Einheit": {
    "tr": "Birim",
    "en": "Unit"
  },
  "Photo": {
    "tr": "Fotoğraf",
    "en": "Photo"
  },
  "Preis": {
    "tr": "Fiyat",
    "en": "Price"
  },
  "Zolltarif & Transport": {
    "tr": "Gümrük tarifesi ve taşıma",
    "en": "Customs tariff & transport"
  },
  "Lagerbestand": {
    "tr": "Depo stoku",
    "en": "Warehouse stock"
  },
  "Vk1 aus EK % berechnen": {
    "tr": "Alış % üzerinden Satış 1 hesapla",
    "en": "Calculate Sale 1 from cost %"
  },
  "EK % anzeigen": {
    "tr": "Alış % göster",
    "en": "Show cost %"
  },
  "Zoll preis (100 kg)": {
    "tr": "Gümrük bedeli (100 kg)",
    "en": "Customs price (100 kg)"
  },
  "Tarif": {
    "tr": "Tarife",
    "en": "Tariff"
  },
  "Brutto Gewicht": {
    "tr": "Brüt ağırlık",
    "en": "Gross weight"
  },
  "Ursprung": {
    "tr": "Menşe",
    "en": "Origin"
  },
  "Lager 1": {
    "tr": "Depo 1",
    "en": "Warehouse 1"
  },
  "Rest": {
    "tr": "Kalan",
    "en": "Remaining"
  },
  "Lagerbestand wird geladen …": {
    "tr": "Depo stoku yükleniyor …",
    "en": "Loading warehouse stock …"
  },
  "Speichert …": {
    "tr": "Kaydediliyor …",
    "en": "Saving …"
  },
  "Erneut speichern": {
    "tr": "Yeniden kaydet",
    "en": "Save again"
  },
  "Aktuellen Stand vergleichen": {
    "tr": "Güncel kayıtla karşılaştır",
    "en": "Compare current record"
  },
  "Änderungen verwerfen und neu laden?": {
    "tr": "Değişikliklerden vazgeçilip yeniden yüklensin mi?",
    "en": "Discard changes and reload?"
  },
  "Neu laden": {
    "tr": "Yeniden yükle",
    "en": "Reload"
  },
  "Aktueller Datenbankstand": {
    "tr": "Veritabanındaki güncel kayıt",
    "en": "Current database record"
  },
  "Diesen Stand für nächsten Speicherversuch verwenden": {
    "tr": "Sonraki kaydetme denemesinde bu sürümü kullan",
    "en": "Use this version for the next save attempt"
  },
  "Ihre Eingaben bleiben erhalten. Prüfen Sie die Abweichungen vor dem erneuten Speichern.": {
    "tr": "Girdileriniz korunur. Yeniden kaydetmeden önce farkları kontrol edin.",
    "en": "Your edits are retained. Check the differences before saving again."
  },
  "Aktueller Datenbankstand wird geladen …": {
    "tr": "Veritabanındaki güncel kayıt yükleniyor …",
    "en": "Loading current database record …"
  },
  "Feld": {
    "tr": "Alan",
    "en": "Field"
  },
  "Ihre Eingabe": {
    "tr": "Girdiniz",
    "en": "Your input"
  },
  "Datenbank": {
    "tr": "Veritabanı",
    "en": "Database"
  },
  "Artikel duplizieren": {
    "tr": "Ürünü çoğalt",
    "en": "Duplicate product"
  },
  "Artikel – {code}": {
    "tr": "Ürün – {code}",
    "en": "Product – {code}"
  },
  "Artikel – Neu": {
    "tr": "Ürün – Yeni",
    "en": "Product – New"
  },
  "Gewichte aktualisieren": {
    "tr": "Ağırlıkları güncelle",
    "en": "Update weights"
  },
  "Vorschau neu laden": {
    "tr": "Önizlemeyi yeniden yükle",
    "en": "Reload preview"
  },
  "Erneut anwenden": {
    "tr": "Yeniden uygula",
    "en": "Apply again"
  },
  "{count} Änderungen anwenden": {
    "tr": "{count} değişikliği uygula",
    "en": "Apply {count} changes"
  },
  "Gewichte werden gespeichert …": {
    "tr": "Ağırlıklar kaydediliyor …",
    "en": "Saving weights …"
  },
  "Letztes positives Bewegungsgewicht; sonst KG/G-Angabe aus der Bezeichnung. Alle Änderungen werden gemeinsam gespeichert.": {
    "tr": "Son pozitif hareket ağırlığı; yoksa açıklamadaki KG/G değeri kullanılır. Tüm değişiklikler birlikte kaydedilir.",
    "en": "Uses the latest positive movement weight, otherwise the KG/G value in the description. All changes are saved together."
  },
  "Ergebnis unklar. Erneut anwenden wiederholt dieselbe Anfrage.": {
    "tr": "Sonuç belirsiz. Yeniden uygula aynı isteği tekrarlar.",
    "en": "Outcome uncertain. Apply again repeats the same request."
  },
  "Gewichtsvorschau wird geladen …": {
    "tr": "Ağırlık önizlemesi yükleniyor …",
    "en": "Loading weight preview …"
  },
  "Bisher (Kg)": {
    "tr": "Önceki (Kg)",
    "en": "Previous (Kg)"
  },
  "Neu (Kg)": {
    "tr": "Yeni (Kg)",
    "en": "New (Kg)"
  },
  "Quelle": {
    "tr": "Kaynak",
    "en": "Source"
  },
  "Letzte Bewegung": {
    "tr": "Son hareket",
    "en": "Latest movement"
  },
  "Kein Photo verfügbar": {
    "tr": "Fotoğraf yok",
    "en": "No photo available"
  },
  "Photo vergrößern": {
    "tr": "Fotoğrafı büyüt",
    "en": "Enlarge photo"
  },
  "Artikel {code}": {
    "tr": "Ürün {code}",
    "en": "Product {code}"
  },
  "Photo – {code}": {
    "tr": "Fotoğraf – {code}",
    "en": "Photo – {code}"
  },
  "Ungültige Grenze für die Artikelauswahl.": {
    "tr": "Ürün seçimi sınırı geçersiz.",
    "en": "Invalid product selection limit."
  },
  "Die Auswahl umfasst {total} Artikel. Höchstens {limit} Artikel können übernommen werden. Bitte die Suche eingrenzen.": {
    "tr": "Seçim {total} ürün içeriyor. En fazla {limit} ürün eklenebilir. Lütfen aramayı daraltın.",
    "en": "The selection contains {total} products. At most {limit} products can be added. Please narrow the search."
  },
  "Die Treffer wurden während der Auswahl geändert. Bitte erneut auswählen.": {
    "tr": "Seçim sırasında sonuçlar değişti. Lütfen yeniden seçin.",
    "en": "The results changed during selection. Please select again."
  },
  "Die Treffer konnten nicht vollständig geladen werden. Bitte erneut auswählen.": {
    "tr": "Sonuçların tamamı yüklenemedi. Lütfen yeniden seçin.",
    "en": "The results could not be loaded completely. Please select again."
  },
  "Keine Artikel mehr gefunden. Bitte die Suche aktualisieren.": {
    "tr": "Artık ürün bulunamıyor. Lütfen aramayı yenileyin.",
    "en": "No products remain. Please refresh the search."
  }
};
